<template>
    <v-container fluid>
        <searchBar :searchBarForm="searchBarForm" :country="country" :textType="textType" />
        <searchResults v-if="results.length > 0 && mode == 'results'" :results="results" />
        <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
        <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
        <individualWork v-if="workId != -1 && mode == 'work'" :id="workId" />
    </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex'
import searchBar from '@/views/search/Searchbar.vue'
import searchResults from '@/views/search/SearchResult.vue'
import individualWork from '@/components/IndividualWork.vue'
// import HelloWorld from '@/components/HelloWorld.vue'

var _country = require('@/assets/country.json')
var _countryAbbr = require('@/assets/countrymap.json')
_countryAbbr = Object.keys(_countryAbbr).map(x => x.toUpperCase())
var _textType = ['descriptive', 'narrative', 'opinion', 'speech', 'contrastive', 'uncategorized']

function find_string_match(answer0, answer1, keyword) {
    return answer1.indexOf(keyword) != -1 || answer0.indexOf(keyword) != -1
}

export default {
    name: 'search',
    components: {
        searchBar,
        searchResults,
        individualWork
    },
    data() {
        return {
            country: _country,
            keyword: '',
            results: [],
            workId: -1,
            searchBarForm: {
                'keyword': "",
                'levelMin': 3,
                'levelMax': 8,
                'levelRange': [3, 8],
                'ageMin': 18,
                'ageMax': 70,
                'ageRange': [15, 70],
                'sex': ['m', 'f'],
                'textType': _textType,
                'country': _countryAbbr,
                // 'countryLoading': true,
                'action': 'search'
            },
            mode: 'results',
            textType: _textType
        }
    },
    watch: {
        $route() {
            this.route_handle()
        }
    },
    methods: {
        ...mapMutations(['addLoading', 'removeLoading']),
        route_handle: function() {
            if (this.$route.query.action == 'search') {
                this.mode = 'results'
                this.search(this.$route.query)
                this.searchBarForm = {
                    'keyword': this.$route.query.keyword,
                    'levelMin': this.$route.query.levelMin,
                    'levelMax': this.$route.query.levelMax,
                    'ageMin': this.$route.query.ageMin,
                    'ageMax': this.$route.query.ageMax,
                    'ageRange': this.$route.query.ageRange,
                    'levelRange': this.$route.query.levelRange,
                    'country': this.$route.query.country,
                    // 'countryLoading': this.$route.query.countryLoading,
                    'sex': this.$route.query.sex,
                    'textType': this.$route.query.textType,
                    'action': 'search'
                }
            } else if (this.$route.params.id) {
                this.mode = 'work'
                this.workId = this.$route.params.id
            } else {
                this.mode = 'results'
                this.results = []
            }
        },
        search: function(sf) {
            this.addLoading('search')
            let q = this.jsonq(this.corpus)
            let f = q.find('id').parent().filter(function() {
                return (sf.country.includes(this.anon_author.substr(0, 2))) &&
                    (this.level >= sf.levelRange[0]) && (this.level <= sf.levelRange[1]) &&
                    (find_string_match(this.answer0, this.answer1, sf.keyword)) &&
                    (sf.sex.includes(this.sex)) &&
                    (this.age >= sf.ageRange[0]) && (this.age <= sf.ageRange[1]) &&
                    (sf.textType.includes(this.text_type))
            })
            this.results = f.value()
            this.removeLoading('search')
        }
    },
    computed: {
        ...mapState({
            corpus: state => state.corpus,
            // country: state => state.country
        })
    },
    mounted() {
        this.route_handle()
    }
}
</script>
